import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setAdministracaoConsultaObras: ['administracao'],
    setTipoConsultaObras: ['tipo'],
    setNaturezaConsultaObras: ['natureza'],
    setExercicioConsultaObras: ['exercicio'],
    setNumeroConsultaObras: ['numero'],
    setDescricaoConsultaObras: ['descricao'],
    setInicioInicialConsultaObras: ['inicioInicial'],
    setInicioFinalConsultaObras: ['inicioFinal'],
    setFimInicialConsultaObras: ['fimInicial'],
    setFimFinalConsultaObras: ['fimFinal'],
    limpaFiltroConsultaObras: [],
    receberFiltroConsultaObras: ['filtroRecebido'],
    setStatusConsultaObras: ['status'],
})

const INITIAL_STATE = {
    administracao: [],
    tipo: [],
    natureza: [],
    exercicio: '',
    numero: '',
    descricao: '',
    inicioInicial: '',
    inicioFinal: '',
    fimInicial: '',
    fimFinal: '',
    status: { label: '', value: '' },
}

const setAdministracao = (state = INITIAL_STATE, action) => {
    return { ...state, administracao: action.administracao }
}

const setTipo = (state = INITIAL_STATE, action) => {
    return { ...state, tipo: action.tipo }
}

const setNatureza = (state = INITIAL_STATE, action) => {
    return { ...state, natureza: action.natureza }
}

const setExercicio = (state = INITIAL_STATE, action) => {
    return { ...state, exercicio: action.exercicio }
}

const setNumero = (state = INITIAL_STATE, action) => {
    return { ...state, numero: action.numero }
}

const setDescricao = (state = INITIAL_STATE, action) => {
    return { ...state, descricao: action.descricao }
}

const setInicioInicial = (state = INITIAL_STATE, action) => {
    return { ...state, inicioInicial: action.inicioInicial }
}

const setInicioFinal = (state = INITIAL_STATE, action) => {
    return { ...state, inicioFinal: action.inicioFinal }
}

const setFimInicial = (state = INITIAL_STATE, action) => {
    return { ...state, fimInicial: action.fimInicial }
}

const setFimFinal = (state = INITIAL_STATE, action) => {
    return { ...state, fimFinal: action.fimFinal }
}

const setStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: action.status }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_ADMINISTRACAO_CONSULTA_OBRAS]: setAdministracao,
    [Types.SET_TIPO_CONSULTA_OBRAS]: setTipo,
    [Types.SET_NATUREZA_CONSULTA_OBRAS]: setNatureza,
    [Types.SET_EXERCICIO_CONSULTA_OBRAS]: setExercicio,
    [Types.SET_NUMERO_CONSULTA_OBRAS]: setNumero,
    [Types.SET_DESCRICAO_CONSULTA_OBRAS]: setDescricao,
    [Types.SET_INICIO_INICIAL_CONSULTA_OBRAS]: setInicioInicial,
    [Types.SET_INICIO_FINAL_CONSULTA_OBRAS]: setInicioFinal,
    [Types.SET_FIM_INICIAL_CONSULTA_OBRAS]: setFimInicial,
    [Types.SET_FIM_FINAL_CONSULTA_OBRAS]: setFimFinal,
    [Types.LIMPA_FILTRO_CONSULTA_OBRAS]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_OBRAS]: receberFiltro,
    [Types.SET_STATUS_CONSULTA_OBRAS]: setStatus,
})
